import React from 'react';

const URL_PATTERN = /((?:https?:\/\/|www\.)[^\s<>"]+)/gi;
const TRAILING_PUNCTUATION = /[.,!?;:'"»…]$/;

function trimTrailing(url) {
  let result = url;
  let tail = '';

  for (;;) {
    const last = result.slice(-1);
    if (TRAILING_PUNCTUATION.test(last)) {
      tail = last + tail;
      result = result.slice(0, -1);
      continue;
    }
    if (last === ')' && (result.match(/\)/g) || []).length > (result.match(/\(/g) || []).length) {
      tail = last + tail;
      result = result.slice(0, -1);
      continue;
    }
    break;
  }

  return [result, tail];
}

const LinkifiedText = ({ text }) => {
  const parts = String(text).split(URL_PATTERN);

  return parts.map((part, index) => {
    if (index % 2 === 0) return part;

    const [url, tail] = trimTrailing(part);
    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;

    return (
      <React.Fragment key={index}>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline break-all hover:text-blue-800"
        >
          {url}
        </a>
        {tail}
      </React.Fragment>
    );
  });
};

export default LinkifiedText;
